/* ========== TNID Wishlist JS (lengva versija, nestringa) ========== */
/*
 * Kas pasikeitė lyginant su sena versija:
 *  - IntersectionObserver: širdelė dedama tik matomoms kortelėms (ne visoms 371 iškart)
 *  - Vienas click listener ant document (event delegation) – jokių listener'ių ant kiekvienos širdelės
 *  - Kortelės žymimos data-tnid="1" – niekada neapdorojamos antrą kartą (nebėra observer ciklo)
 *  - Debounce'intas MutationObserver, jokio getComputedStyle (position per CSS)
 */
(function () {
  "use strict";

  var KEY = "tnid_wishlist_v1";

  /* ---------- localStorage ---------- */
  function loadList() {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
    catch (e) { return []; }
  }
  function saveList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list || [])); } catch (e) {}
    updateBadge();
  }
  function contains(handle) {
    return loadList().some(function (x) { return x && x.handle === handle; });
  }
  function toggleItem(item) {
    var list = loadList();
    var idx = list.findIndex(function (x) { return x && x.handle === item.handle; });
    if (idx > -1) list.splice(idx, 1);
    else list.push(item);
    saveList(list);
    return idx === -1; // true => pridėta
  }

  /* ---------- pagalbinės ---------- */
  function extractHandle(url) {
    var m = (url + "").match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : "";
  }

  // Randa kortelės "konteinerį" nuo produkto nuorodos
  function cardFromLink(link) {
    return link.closest(
      "article, .card, .product-card, .product-item, .product-grid-item, .grid__item, [data-product-id]"
    ) || link.parentElement;
  }

  // Kur dėti širdelę (paveikslėlio konteineris)
  function mediaFromCard(card) {
    var media = card.querySelector(
      ".card__media, .product-card__media, .media, .product-item__image, .product-card__image, .grid-product__image, .card__inner"
    );
    if (!media) {
      var img = card.querySelector("img");
      media = img ? img.parentElement : card;
    }
    return media;
  }

  function getCardInfo(card, link) {
    var url = link.getAttribute("href") || "";
    var handle = extractHandle(url);
    if (!handle) return null;

    var titleEl = card.querySelector(
      ".card__heading, .product-card__title, .product-item__title, .product-title, h3, h2"
    );
    var title = (titleEl && titleEl.textContent
      ? titleEl.textContent.trim()
      : (link.textContent || "").trim()) || "Produktas";

    var img = card.querySelector("img");
    var imgSrc = img ? (img.getAttribute("src") || img.currentSrc || "") : "";

    var priceEl = card.querySelector(".price, .price-item, .product-price, [data-price], .money");
    var price = priceEl && priceEl.textContent ? priceEl.textContent.trim() : "";

    return { handle: handle, url: url, title: title, image: imgSrc, price: price };
  }

  /* ---------- širdelės mygtuko įdėjimas (vienai kortelei) ---------- */
  var HEART_SVG =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path class="tnid-heart-stroke" d="M12 21s-7-4.5-9.5-9A5.8 5.8 0 0 1 12 6.2 5.8 5.8 0 0 1 21.5 12C19 16.5 12 21 12 21Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>' +
    '<path class="tnid-heart-fill" d="M12 21s-7-4.5-9.5-9A5.8 5.8 0 0 1 12 6.2 5.8 5.8 0 0 1 21.5 12C19 16.5 12 21 12 21Z" fill="currentColor"/>' +
    "</svg>";

  function injectOnCard(card) {
    if (!card || card.getAttribute("data-tnid") === "1") return;
    if (card.closest("#tnid-wishlist-page")) return; // wishlist puslapio neliečiam
    card.setAttribute("data-tnid", "1"); // pažymim iškart – daugiau neliesim

    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    if (card.querySelector(".tnid-wish-btn")) return;

    var info = getCardInfo(card, link);
    if (!info) return;

    var media = mediaFromCard(card);
    media.classList.add("tnid-wish-host"); // position:relative per CSS, be reflow

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "tnid-wish-btn" + (contains(info.handle) ? " is-active" : "");
    btn.setAttribute("aria-label", "Pridėti į mėgstamiausius");
    btn.setAttribute("data-handle", info.handle);
    btn.setAttribute("data-url", info.url);
    btn.setAttribute("data-title", info.title);
    btn.setAttribute("data-image", info.image);
    btn.setAttribute("data-price", info.price);
    btn.innerHTML = HEART_SVG;
    media.appendChild(btn);
  }

  /* ---------- IntersectionObserver: apdorojam tik matomas korteles ---------- */
  var io = ("IntersectionObserver" in window)
    ? new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            var card = entries[i].target;
            io.unobserve(card);
            injectOnCard(card);
          }
        }
      }, { rootMargin: "300px 0px" }) // pradedam ruošti kiek anksčiau nei įscrollina
    : null;

  function scan() {
    var links = document.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      // wishlist puslapio kortelių neliečiam – jos jau turi savo mygtukus
      if (links[i].closest("#tnid-wishlist-page")) continue;
      var card = cardFromLink(links[i]);
      if (!card || card.getAttribute("data-tnid") === "1") continue;
      if (card.getAttribute("data-tnid-seen") === "1") continue;
      card.setAttribute("data-tnid-seen", "1");
      if (io) io.observe(card);
      else injectOnCard(card); // fallback senoms naršyklėms
    }
  }

  /* ---------- vienas click listener visai parduotuvei ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".tnid-wish-btn");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var info = {
      handle: btn.getAttribute("data-handle"),
      url: btn.getAttribute("data-url"),
      title: btn.getAttribute("data-title"),
      image: btn.getAttribute("data-image"),
      price: btn.getAttribute("data-price")
    };
    var added = toggleItem(info);
    btn.classList.toggle("is-active", added);
  });

  /* ---------- badge apatiniame meniu ---------- */
  function updateBadge() {
    var count = loadList().length;
    var badges = document.querySelectorAll(".tnid-wish-badge");
    for (var i = 0; i < badges.length; i++) {
      if (count > 0) { badges[i].classList.add("is-on"); badges[i].textContent = String(count); }
      else { badges[i].classList.remove("is-on"); badges[i].textContent = ""; }
    }
  }

  /* ---------- /pages/megstamiausi ---------- */

  // Kainos formatavimas: 142200 (centai) -> "€1.422,00"
  function formatPrice(cents) {
    var v = (Number(cents) / 100).toFixed(2).split(".");
    var intPart = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return "€" + intPart + "," + v[1];
  }

  // Vienkartinis stiliaus įterpimas (nereikia liesti CSS failo)
  function injectPageStyles() {
    if (document.getElementById("tnid-wpage-css")) return;
    var css =
      "#tnid-wishlist-page{max-width:1200px;margin:0 auto;padding:0 16px 60px;}" +
      ".tnid-wlist-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:20px;}" +
      "@media(max-width:749px){.tnid-wlist-grid{grid-template-columns:repeat(2,1fr);gap:12px;}}" +
      ".tnid-wcard{border:1px solid #e4ded4;background:#fff;display:flex;flex-direction:column;overflow:hidden;transition:box-shadow .2s;}" +
      ".tnid-wcard:hover{box-shadow:0 6px 20px rgba(0,0,0,.08);}" +
      ".tnid-wcard__media{display:block;background:#f3f0ea;aspect-ratio:1/1;overflow:hidden;}" +
      ".tnid-wcard__media img{width:100%;height:100%;object-fit:contain;display:block;mix-blend-mode:multiply;}" +
      ".tnid-wcard__body{padding:14px 14px 16px;display:flex;flex-direction:column;gap:6px;flex:1;}" +
      ".tnid-wcard__row{display:flex;justify-content:space-between;align-items:baseline;gap:10px;}" +
      ".tnid-wcard__title{font-size:15px;font-weight:600;color:#2a2a2a;text-decoration:none;line-height:1.3;}" +
      ".tnid-wcard__title:hover{text-decoration:underline;}" +
      ".tnid-wcard__price{font-size:15px;font-weight:700;color:#2a2a2a;white-space:nowrap;}" +
      ".tnid-wcard__remove{margin-top:auto;background:none;border:0;padding:8px 0 0;color:#9a9a9a;font-size:13px;cursor:pointer;text-align:left;align-self:flex-start;}" +
      ".tnid-wcard__remove:hover{color:#e23b3b;text-decoration:underline;}" +
      ".tnid-wempty{padding:40px 0;color:#777;font-size:16px;}";
    var s = document.createElement("style");
    s.id = "tnid-wpage-css";
    s.textContent = css;
    document.head.appendChild(s);
  }

  function renderWishlistPage() {
    var root = document.getElementById("tnid-wishlist-page");
    if (!root) return;
    injectPageStyles();

    var list = loadList();
    root.innerHTML = "";

    if (!list.length) {
      var empty = document.createElement("div");
      empty.className = "tnid-wempty";
      empty.textContent = "Kol kas neturite išsaugotų prekių.";
      root.appendChild(empty);
      return;
    }

    var grid = document.createElement("div");
    grid.className = "tnid-wlist-grid";
    root.appendChild(grid);

    // vienas listener puslapiui (delegacija)
    grid.addEventListener("click", function (e) {
      var rm = e.target.closest(".tnid-wcard__remove");
      if (!rm) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = rm.getAttribute("data-remove");
      var newList = loadList().filter(function (x) { return x.handle !== handle; });
      saveList(newList);
      renderWishlistPage();
    });

    // kiekvienai prekei atsisiunčiam TIKSLIUS duomenis iš Shopify
    list.forEach(function (it) {
      var card = document.createElement("div");
      card.className = "tnid-wcard";
      card.setAttribute("data-handle", it.handle);
      grid.appendChild(card);

      function draw(title, price, image, url) {
        card.innerHTML =
          '<a class="tnid-wcard__media" href="' + url + '">' +
          (image ? '<img src="' + image + '" alt="" loading="lazy">' : "") +
          "</a>" +
          '<div class="tnid-wcard__body">' +
          '<div class="tnid-wcard__row">' +
          '<a class="tnid-wcard__title" href="' + url + '">' + title + "</a>" +
          (price ? '<span class="tnid-wcard__price">' + price + "</span>" : "") +
          "</div>" +
          '<button class="tnid-wcard__remove" type="button" data-remove="' + it.handle + '">Pašalinti</button>' +
          "</div>";
      }

      // pirmiausia parodom kas išsaugota (kad nemirksėtų), tada atnaujinam
      draw(it.title || "…", it.price || "", it.image || "", it.url || ("/products/" + it.handle));

      fetch("/products/" + it.handle + ".js", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var img = p.featured_image || (p.images && p.images[0]) || it.image || "";
          if (img && img.indexOf("//") === 0) img = "https:" + img;
          draw(p.title, formatPrice(p.price), img, p.url || ("/products/" + p.handle));
          // atnaujinam ir localStorage, kad kitą kartą būtų teisinga
          var l = loadList();
          var i = l.findIndex(function (x) { return x.handle === it.handle; });
          if (i > -1) {
            l[i].title = p.title;
            l[i].price = formatPrice(p.price);
            l[i].image = img;
            l[i].url = p.url || ("/products/" + p.handle);
            try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {}
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- debounce'intas observer naujam turiniui ---------- */
  var t = null;
  function scheduleScan() {
    if (t) return;
    t = setTimeout(function () { t = null; scan(); }, 250);
  }

  function watch() {
    if (!("MutationObserver" in window)) return;
    var mo = new MutationObserver(function (muts) {
      // ignoruojam pakeitimus, kuriuos sukėlėm patys (mūsų mygtukas)
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && n.querySelector && n.querySelector('a[href*="/products/"]')) {
            scheduleScan();
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- start ---------- */
  function init() {
    scan();
    updateBadge();
    renderWishlistPage();
    watch();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();